module.exports = __webpack_public_path__ + "img/다크로드.1a272eb2.png";